<template>
  <marginSettingDetailForm :detailData="tableData" :currency="currency"
                           :loading="loading"></marginSettingDetailForm>
</template>

<script>
import marginSettingDetailForm from '@/view/quote/components/forms/margin-setting-detail-form'
export default {
  name: 'CostSummaryDetail',
  components: {
    marginSettingDetailForm
  },
  props: {
    data: {
      type: Array,
      required: false,
      default: () => {
        return []
      }
    },
    currency: {
      type: String,
      default: 'CNY'
    },
    loading: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    tableData: function () {
      let data = this.data
      if (!_.isEmpty(this.filters)) {
        const filterIds = _.pick(this.filters, ['accounting_term_id', 'associated_term_id', 'summary_term_id'])
        data = _.filter(this.data, filterIds)
      }
      let grouped = _.groupBy(data, (e) => {
        let groupValues = [
          _.get(e, 'model_type', '_'),
          _.get(e, 'accounting_term_id', '_'),
          _.get(e, 'associated_term_id', '_'),
          _.get(e, 'summary_term_id', '_'),
          _.get(e, 'model.id', '_')
        ]
        return groupValues.join('-')
      })
      return _.map(grouped, (items) => {
        let o = _.pick(_.head(items), [
          'model_type', 'model', 'accounting_term', 'summary_term', 'associated_term'
        ])
        let obj = _.map(items, (data) => {
          return _.pick(data, [
            "cost_quantity",
            "quantity",
            "currency",
            "cost",
            'cost_taxed',
            "price",
            "price_taxed",
            "price_amount",
            "price_amount_taxed",
            "tax_rate",
            "margin",
            "is_taxed",
            "date",
            "vat_amount",
            "scrap_amount",
            "created_at",
            "updated_at"
          ])
        })
        o = Object.assign({}, o, obj[0])
        return o
      })
    }
  }
}
</script>

<style lang="less">

</style>
